import { render, staticRenderFns } from "./DynamicCard.vue?vue&type=template&id=4b916180&scoped=true&"
import script from "./DynamicCard.vue?vue&type=script&lang=ts&"
export * from "./DynamicCard.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicCard.vue?vue&type=style&index=0&id=4b916180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b916180",
  null
  
)

export default component.exports